module.exports = __webpack_public_path__ + "static/media/androidMock.34c643aa.png";